import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import DailyLogTab from "./DailyLogTab";
import DieselFillingTab from "./DieselFillingTab";
import ServiceLogTab from "./ServiceLogTab";
import BreakdownTab from "./BreakdownTab";
import SiteLogUploadTab from "./SiteLogUploadTab";
import BulletConsumptionTab from "./BulletConsumptionTab";
import ServiceHistoryTab from "./ServiceHistoryTab";
import { NoAccess } from "./shared/NoAccess";

const ALL_SIX = ["Operator", "Director", "Manager", "Accounts", "Back Office"];
const HISTORY_ROLES = ["Operator", "Mechanical"];

// HMR Review Queue and Missing Daily Log tabs hidden from nav (Batch 1,
// Sep 2026) — underlying routers/data untouched, can be brought back later.
const TABS = [
  { key: "daily-log", label: "Daily Log", Component: DailyLogTab, roles: ALL_SIX },
  { key: "diesel-filling", label: "Diesel Filling", Component: DieselFillingTab, roles: ALL_SIX },
  { key: "service-log", label: "Service Log", Component: ServiceLogTab, roles: ALL_SIX },
  { key: "breakdown", label: "Breakdown", Component: BreakdownTab, roles: ALL_SIX },
  { key: "site-log-upload", label: "Site Log Upload", Component: SiteLogUploadTab, roles: ALL_SIX },
  { key: "bullet-consumption", label: "Bullet Consumption", Component: BulletConsumptionTab, roles: ALL_SIX },
  { key: "service-history", label: "Service History", Component: ServiceHistoryTab, roles: HISTORY_ROLES },
];

export default function EquipmentPage() {
  const { user } = useAuth();
  const visible = TABS.filter((t) => t.roles.includes(user?.role));
  const [active, setActive] = useState(visible[0]?.key);

  if (visible.length === 0) return <NoAccess />;

  return (
    <div className="space-y-6" data-testid="equipment-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
          Equipment / FleetCare
        </h1>
        <p className="text-sm text-slate-500">Daily logs, diesel filling, service, breakdown and machine review.</p>
      </div>
      <Tabs value={active} onValueChange={setActive}>
        <TabsList className="flex-wrap h-auto">
          {visible.map((t) => (
            <TabsTrigger key={t.key} value={t.key} data-testid={`equipment-tab-${t.key}`}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {visible.map((t) => (
          <TabsContent key={t.key} value={t.key} className="pt-4">
            <t.Component />
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
